import { useRef, useEffect } from 'react';
import { pick, isEqual } from 'lodash';

const useControlledState = (state, initialState, rows, loading, selectRowRange, onRowSelectionChanged, onStateChanged) => {
    const stateRef = useRef();
    const selectionRef = useRef();
    const rangeSelectionRef = useRef();
    const { rowSelectionRange, selectedRowIds } = state;
    useEffect(() => {
        if (!rangeSelectionRef.current && !loading) {
            rangeSelectionRef.current = true;
        }
        if (rangeSelectionRef.current && rowSelectionRange) {
            const { start, end } = rowSelectionRange;
            if (start && end) {
                const startIndex = rows.findIndex(row => row.id === start);
                const endIndex = rows.findIndex(row => row.id === end);
                const startAbsolute = Math.min(startIndex, endIndex);
                const endAbsolute = Math.max(startIndex, endIndex);
                const toSelect = selectedRowIds[end];
                rows.map(row => {
                    const rowIndex = rows.findIndex(({ id }) => row.id === id);
                    if (rowIndex >= startAbsolute && rowIndex <= endAbsolute) {
                        selectedRowIds[row.id] = toSelect;
                    }
                });
                selectRowRange(selectedRowIds);
            }
        }
    }, [selectedRowIds, rowSelectionRange, onRowSelectionChanged, rows, selectRowRange, rangeSelectionRef, loading]);
    useEffect(() => {
        if (!selectionRef.current && !loading) {
            selectionRef.current = true;
        }
        if (selectionRef.current) {
            onRowSelectionChanged && onRowSelectionChanged(selectedRowIds);
        }
        // NOTE: This eslint warning was disabled in order to enable a pre-push hook. It doesn't mean that the warning isn't
        // valid. Whoever touches this code, please try removing the eslint-disable-next-line comment and fix the problem.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedRowIds, selectionRef, loading]);
    const lastStateRef = useRef(initialState);
    useEffect(() => {
        if (!stateRef.current && !loading) {
            stateRef.current = true;
        }
        if (stateRef.current && onStateChanged) {
            const newState = pick(state, ['columnOrder', 'columnSizing', 'sortBy']);
            if (!isEqual(lastStateRef.current, newState)) {
                onStateChanged(newState);
                lastStateRef.current = newState;
            }
        }
    }, [stateRef, onStateChanged, state, loading]);
};

export { useControlledState as default, useControlledState };
//# sourceMappingURL=useControlledState.js.map
